import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { BaseService } from "./base-service";
import { Observable } from "rxjs";
import {
  AddLearningResourcesDto,
  LearningResource,
  LearningResourceItem,
  RemoveLearningResourcesDto,
  UpdateActivityDueDateDto,
  UpdateLearningResourceDto,
} from "../_models/LearningResource";
import { AppConstants } from "../constants/constants";
import { MessageResultDto } from "../_models/MessageResultDto";

@Injectable({
  providedIn: "root",
})
export class LearningResourcesService extends BaseService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "LearningResources/";
  private static readonly GET_LEARNING_RESOURCES = "getlearningresources";
  private static readonly UPDATE_LEARNING_RESOURCES = "updatelearningresources";
  private static readonly RESET_LEARNING_RESOURCES = "resetlearningresources";
  private static readonly ADD_LEARNING_RESOURCES = "addlearningresources";
  private static readonly UPDATE_ACTIVITY_DUEDATE = "updateactivityduedate";
  private static readonly REMOVE_LEARNING_RESOURCES = "removelearningresources";
  private static readonly GET_MODULETYPES = "getmoduletypes";
  private static readonly GET_LEARNING_RESOURCE_ITEMS =
    "getlearningresourcesitems";

  constructor(
    http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
    super(http);
  }

  public getLearningResources$(
    courseId: number,
    learnerId: number,
    subCategoryCode: string,
    isInitialLoad: boolean
  ): Observable<LearningResource> {
    let params = new HttpParams();
    params = params.append(AppConstants.COURSE_ID, String(courseId));
    params = params.append(AppConstants.LEARNER_ID, String(learnerId));
    params = params.append(
      AppConstants.SUBCATEGORYCODE,
      String(subCategoryCode)
    );
    params = params.set(AppConstants.IS_INITIAL_LOAD, String(isInitialLoad));

    return this.http.get<LearningResource>(
      this.baseUrl +
        LearningResourcesService.path +
        LearningResourcesService.GET_LEARNING_RESOURCES,
      { params }
    );
  }

  public updateLearningResources$(
    updateLearningResourceDto: UpdateLearningResourceDto
  ): Observable<object> {
    return this.http.put(
      `${this.baseUrl}${LearningResourcesService.path}${LearningResourcesService.UPDATE_LEARNING_RESOURCES}`,
      updateLearningResourceDto
    );
  }

  public resetLearningResources$(): Observable<boolean> {
    return this.http.get<boolean>(
      this.baseUrl +
        LearningResourcesService.path +
        LearningResourcesService.RESET_LEARNING_RESOURCES
    );
  }

  public addLearningResources$(
    addLearningResourcesDto: AddLearningResourcesDto
  ): Observable<MessageResultDto> {
    return this.http.post<MessageResultDto>(
      `${this.baseUrl}${LearningResourcesService.path}${LearningResourcesService.ADD_LEARNING_RESOURCES}`,
      addLearningResourcesDto
    );
  }

  public updateActivityDueDate$(
    updateActivityDueDateDto: UpdateActivityDueDateDto
  ): Observable<MessageResultDto> {
    return this.http.put<MessageResultDto>(
      `${this.baseUrl}${LearningResourcesService.path}${LearningResourcesService.UPDATE_ACTIVITY_DUEDATE}`,
      updateActivityDueDateDto
    );
  }

  public removeLearningResources$(
    removeLearningResourcesDto: RemoveLearningResourcesDto
  ): Observable<MessageResultDto> {
    return this.http.put<MessageResultDto>(
      `${this.baseUrl}${LearningResourcesService.path}${LearningResourcesService.REMOVE_LEARNING_RESOURCES}`,
      removeLearningResourcesDto
    );
  }

  public getModuleTypes$(courseId: number): Observable<string[]> {
    let params = new HttpParams();
    params = params.append(AppConstants.COURSE_ID, String(courseId));

    return this.http.get<string[]>(
      this.baseUrl +
        LearningResourcesService.path +
        LearningResourcesService.GET_MODULETYPES,
      { params }
    );
  }

  public getLearningResourceItemsByObjectIds$(
    learnerId: number,
    courseId: number,
    objectIds: string[]
  ): Observable<LearningResourceItem[]> {
    let params = new HttpParams();
    params = params.append(AppConstants.LEARNER_ID, String(learnerId));
    params = params.append(AppConstants.COURSE_ID, String(courseId));

    return this.http.put<LearningResourceItem[]>(
      this.baseUrl +
        LearningResourcesService.path +
        LearningResourcesService.GET_LEARNING_RESOURCE_ITEMS,
      objectIds,
      { params }
    );
  }
}
